import React, { useContext } from 'react'
//import { Navigate } from 'react-router-dom'
import styled from 'styled-components'
import { ProjectContext } from '../context/ProjectContext'
import { NormalContainer, Heading, SubHeading, Divider } from '../global-styles';
import getData from '../helpers/getData'
import { Project } from '../components'

export default function Projects() {

    const { projects, setProjects } = useContext(ProjectContext);

    if(!projects){
        getData(setProjects);
    }
    
    return (
        <React.Fragment>
            <Container>
                <Heading>
                    My Projects
                </Heading>
                <SubHeading>
                    From one page sites to learning and designing a huge plethora of WebApps, I spend majority of my time in programming &amp; learning about the new advances in tech and honing my skills to higher levels. Here’s a small selection of some of my recent projects and experiences.
                </SubHeading>
                <Divider />
                <ProjectContainer>
                    {projects &&
                        projects.map((p,i) => 
                            <Project key={`${p.name.toLowerCase}-${i}`} project={p} />
                        )
                    }
                </ProjectContainer>
            </Container>
        </React.Fragment>
    );
}

const Container = styled(NormalContainer)`
    padding: 0;
    margin: 48px auto;
    max-width: 1000px;
    box-sizing: border-box;
`;

const ProjectContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;

    @media screen and (max-width: 1000px) {
        flex-flow: column wrap;
    }
`;